// Platform-wide timezone (set once from agency settings at app load).
let PLATFORM_TZ = "Australia/Brisbane";

export function setPlatformTz(tz) { if (tz) PLATFORM_TZ = tz; }
export function getPlatformTz() { return PLATFORM_TZ; }

export function tzList() {
  try { return Intl.supportedValuesOf("timeZone"); }
  catch {
    return ["Australia/Brisbane", "Australia/Sydney", "Australia/Melbourne", "Australia/Adelaide", "Australia/Perth", "Australia/Darwin", "Australia/Hobart",
            "Pacific/Auckland", "America/New_York", "America/Chicago", "America/Denver", "America/Los_Angeles", "Europe/London", "Europe/Paris", "Asia/Singapore", "Asia/Dubai", "UTC"];
  }
}

export function fmtDate(iso, opts) {
  if (!iso) return "";
  try { return new Date(iso).toLocaleDateString("en-AU", { timeZone: PLATFORM_TZ, day: "2-digit", month: "short", year: "numeric", ...(opts || {}) }); }
  catch { return ""; }
}

export function fmtDateTime(iso) {
  if (!iso) return "";
  try { return new Date(iso).toLocaleString("en-AU", { timeZone: PLATFORM_TZ, day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }); }
  catch { return ""; }
}

// Compact history stamp, e.g. "22-09-26 3:43PM" (platform timezone).
export function fmtHistoryTime(iso) {
  if (!iso) return "";
  try {
    const parts = new Intl.DateTimeFormat("en-AU", { timeZone: PLATFORM_TZ, day: "2-digit", month: "2-digit", year: "2-digit", hour: "numeric", minute: "2-digit", hour12: true }).formatToParts(new Date(iso));
    const g = (t) => (parts.find((p) => p.type === t) || {}).value || "";
    const ap = g("dayPeriod").replace(/\s/g, "").toUpperCase();
    return `${g("day")}-${g("month")}-${g("year")} ${g("hour")}:${g("minute")}${ap}`;
  } catch { return ""; }
}

// Today's date as YYYY-MM-DD in the platform timezone.
export function todayStr() {
  try { return new Intl.DateTimeFormat("en-CA", { timeZone: PLATFORM_TZ, year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date()); }
  catch { return new Date().toISOString().slice(0, 10); }
}

// The calendar date (YYYY-MM-DD) of a UTC timestamp, in the platform timezone.
export function dateStrOf(iso) {
  if (!iso) return null;
  try { return new Intl.DateTimeFormat("en-CA", { timeZone: PLATFORM_TZ, year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date(iso)); }
  catch { return (iso || "").slice(0, 10); }
}
